module.exports = __webpack_public_path__ + "static/img/3.01647ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/3.png
// module id = Z94E
// module chunks = 0